/** Epoch milliseconds for a compact (yyyyMMdd) or ISO date, or null when it cannot be parsed. */
export function toDateSortValue(value: string): number | null {
  const text = value?.trim();
  if (!text) {
    return null;
  }

  const compactMatch = /^(\d{4})(\d{2})(\d{2})$/.exec(text);
  const time = compactMatch
    ? new Date(Number(compactMatch[1]), Number(compactMatch[2]) - 1, Number(compactMatch[3])).getTime()
    : new Date(text).getTime();

  return Number.isNaN(time) ? null : time;
}

export function formatCompactOrIsoDate(value: string): string {
  if (!value) {
    return '-';
  }

  const compactMatch = /^(\d{4})(\d{2})(\d{2})$/.exec(value.trim());
  if (compactMatch) {
    const [, yearText, monthText, dayText] = compactMatch;
    const year = Number(yearText);
    const month = Number(monthText);
    const day = Number(dayText);
    const compactDate = new Date(year, month - 1, day);

    if (
      !Number.isNaN(compactDate.getTime())
      && compactDate.getFullYear() === year
      && compactDate.getMonth() === month - 1
      && compactDate.getDate() === day
    ) {
      return formatUsDate(compactDate);
    }
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return value;
  }

  return formatUsDate(parsed);
}

export function formatCurrencyAmount(
  currency: string,
  amount: number,
  maximumFractionDigits = 2,
): string {
  if (!Number.isFinite(amount)) {
    return '-';
  }

  const formattedAmount = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits,
  }).format(Math.abs(amount));

  const trimmedCurrency = currency.trim();
  if (!trimmedCurrency) {
    return formattedAmount;
  }

  return `${trimmedCurrency} ${formattedAmount}`;
}

function formatUsDate(value: Date): string {
  return new Intl.DateTimeFormat('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  }).format(value);
}
